export default __webpack_public_path__ + "static/media/image2pro5.02c3f708.jpeg";